// extracted by mini-css-extract-plugin
export default {"body":"Cv_body__9gQyB","alternative":"Cv_alternative__4SiE5","cv":"Cv_cv__9BeZj","audio":"Cv_audio__KIuX9"};